import * as React from 'react';
import { Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { Communicator } from '../../tools/Communication';

export default function EditGrafanaQueryConfigPage() {
  const [queryOptions, setQueryOptions] = useState('[]');
  const [queries, setQueries] = useState('{}');
  const [newQuery, setNewQuery] = useState('');
  const [newQueryName, setNewQueryName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      Communicator.Get('/Config/GetConfigValue', { key: 'GrafanaQueryOptions' })
        .then((response) => response.text())
        .then((text) => setQueryOptions(text)),
      Communicator.Get('/Config/GetConfigValue', { key: 'GrafanaQueries' })
        .then((response) => response.text())
        .then((text) => setQueries(text)),
    ]).then(() => setIsLoading(false));
  }, []);

  const keyWordMap: { [key: string]: string } = {
    '@stores': '"stores":"$Outlets"',
    '@containerTypes': '"containerTypes":"$ContainerTypes"',
    '@userId': '"userId":"$UserId"',
    '@extraIds': '"extraIds":"$ExtraIds"',
    '@lang': '"lang":"$Lang"',
    '@userIds': '"userIds":"$UserIds"',
    '@clusterInterval': '"clusterInterval":"$ClusterInterval"',
    '@country': '"country":"$Country"',
    '@franchise': '"franchise":"$Franchise"',
    '@cateringIds': '"cateringIds":"$CateringIds"',
    '@regionIds': '"regionIds":"$RegionIds"',
    '@cities': '"cities":"$Cities"',
    '@categoryIds': '"categoryIds":"$CategoryIds"',
    '@merchant': '"merchant":"$Merchant"',
    '@countries': '"countries":"$Countries"',
  };

  async function saveGrafanaQueryConfig() {
    setIsLoading(true);
    const testQueryResult = await Communicator.PostData(
      '/api/3/grafana/TestQuery',
      {
        query: newQuery,
      },
    );
    if (testQueryResult.status !== 200) {
      setIsLoading(false);
      const res = await testQueryResult.json();
      alert(JSON.stringify(res));
      return;
    }
    const queriesJson: { [key: string]: string } = JSON.parse(queries);
    const newId =
      Math.max(...Object.keys(queriesJson).map((k) => parseInt(k))) + 1;
    queriesJson[newId.toString()] = newQuery;
    const updatedQueries = JSON.stringify(queriesJson);

    let newQueryOption = `{"id":${newId},"type":"database","metric_name":"${newQueryName}"`;
    for (const keyWord of Object.keys(keyWordMap)) {
      if (newQuery.includes(keyWord)) {
        newQueryOption += `,${keyWordMap[keyWord]}`;
      }
    }
    newQueryOption += '}';
    const queryOptionsJson: string[] = JSON.parse(queryOptions);
    queryOptionsJson.push(newQueryOption);
    const updatedQueryOptions = JSON.stringify(queryOptionsJson);
    try {
      console.log({ queryOptions, queries });
      let result = await Communicator.PostData('/Config/SetConfigValue', {
        Key: 'GrafanaQueries',
        Value: updatedQueries,
      });

      setQueries(await result.text());
      result = await Communicator.PostData('/Config/SetConfigValue', {
        Key: 'GrafanaQueryOptions',
        Value: updatedQueryOptions,
      });
      setQueryOptions(await result.text());
    } catch (e) {
      alert('Error saving Grafana query config');
    }
    setIsLoading(false);
  }

  return (
    <div>
      <h4>Variable Mapping</h4>

      <textarea
        className="form-control"
        disabled
        rows={Object.values(keyWordMap).length}
        value={Object.values(keyWordMap)
          .map((v) => `@${v.replaceAll('"', '')}`)
          .join('\r\n')}
      ></textarea>
      <br />
      <h4>Example Queries</h4>
      <textarea
        className="form-control"
        disabled
        rows={8}
        value={Object.values(JSON.parse(queries)).join('\r\n')}
      ></textarea>
      <br />
      <h4>Add Query</h4>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          Query Name
        </span>
        <input
          className="form-control"
          value={newQueryName}
          onChange={(e) => setNewQueryName(e.target.value)}
        />
      </div>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          New Query
        </span>
        <input
          className="form-control"
          value={newQuery}
          onChange={(e) => setNewQuery(e.target.value)}
        />
      </div>
      <Button color="primary" size="sm" onClick={saveGrafanaQueryConfig}>
        {isLoading ? 'Saving...' : 'Save'}
      </Button>
    </div>
  );
}
